<common-weight-height
    [data]="data"
    [showLabel]="config.showLabel"
    [editMode]="editMode"
></common-weight-height>

<ng-container *ngIf="config.showCalculatedValues">
    <div class="calculated">
        <p class="span-box">{{ config.bmiLabel }}: {{ bmiValue }}</p>
    </div>

    <div *ngIf="config.showHeight" class="calculated">
        <p class="span-box">{{ config.heightLabel }}: {{ heightValue }}</p>
    </div>

    <div *ngIf="config.showWeight" class="calculated">
        <p class="span-box">{{ config.weightLabel }}: {{ weightValue }}</p>
    </div>
</ng-container>
